import React from 'react';
import { Lightbulb, TrendingUp, Target, Activity } from 'lucide-react';
import type { MetaInsight } from '../../types/analytics';

interface InsightCardProps {
  insight: MetaInsight;
}

export const InsightCard: React.FC<InsightCardProps> = ({ insight }) => {
  const getIcon = () => {
    switch (insight.type) {
      case 'connection':
        return <Activity className="h-5 w-5 text-primary-600" />;
      case 'coverage':
        return <Target className="h-5 w-5 text-sage-600" />;
      case 'trend':
        return <TrendingUp className="h-5 w-5 text-[var(--mustard)]" />;
      case 'pattern':
        return <Lightbulb className="h-5 w-5 text-coral-600" />;
    }
  };

  const getTypeColor = () => {
    switch (insight.type) {
      case 'connection':
        return 'bg-primary-50 border-primary-200';
      case 'coverage':
        return 'bg-sage-50 border-sage-200';
      case 'trend':
        return 'bg-[var(--mustard-dim)] border-[var(--mustard)]';
      case 'pattern':
        return 'bg-coral-50 border-coral-200';
    }
  };

  return (
    <div className={` border p-4 ${getTypeColor()}`}>
      <div className="flex items-start gap-3">
        <div className="mt-0.5">{getIcon()}</div>
        <div className="flex-1 space-y-2">
          <div>
            <h4 className="font-semibold text-charcoal-900">{insight.title}</h4>
            <p className="text-sm text-charcoal-700 mt-1">{insight.description}</p>
          </div>
          
          {insight.actionable && (
            <div className="bg-[var(--bg-raised)] bg-opacity-60 rounded px-3 py-2 text-sm text-charcoal-700">
              💡 {insight.actionable}
            </div>
          )}
        </div>
        
        <div className="text-right">
          <div className="text-2xl font-bold text-charcoal-900">{insight.metric}</div>
          <div className="text-xs text-charcoal-600 mt-1 capitalize">{insight.trend}</div>
        </div>
      </div>
    </div>
  );
};

